module.exports = __webpack_public_path__ + "img/question.ccb4d790.svg";